/**
 * Mixin to surface descriptive error messages when PDFMonkey calls fail.
 *
 * Use it from any view that calls api.pdfmonkey.io. In the catch block,
 * call `this.notifyPdfMonkeyError(e)`. If the error came from PDFMonkey,
 * a descriptive notification is shown and the method returns true so the
 * caller can skip its generic fallback.
 *
 * Detection covers:
 *  - HTTP 402 Payment Required (PDFMonkey returns this when the workspace
 *    has no credits left).
 *  - Response bodies mentioning credit / quota / subscription / payment.
 *  - Documents that came back with status "failure" and a failure_cause
 *    that hints at billing issues.
 */
export default {
  methods: {
    notifyPdfMonkeyError (e) {
      if (!e) return false

      const url = (e.config && e.config.url) || ''
      const isPdfMonkey = url.includes('pdfmonkey.io')
      if (!isPdfMonkey) return false

      const status = e.response && e.response.status
      const data = (e.response && e.response.data) || {}
      const haystack = JSON.stringify(data).toLowerCase()

      const looksLikeCredits =
        status === 402 ||
        /credit|quota|subscription|payment|insufficient|exhaust/.test(haystack)

      if (looksLikeCredits) {
        this.$vs.notify({
          color: 'danger',
          title: 'Sin créditos para generar PDF',
          text: 'La cuenta de PDFMonkey se quedó sin créditos. Contacta al administrador para recargar el plan y poder seguir generando comprobantes.',
          time: 8000
        })
        return true
      }

      this.$vs.notify({
        color: 'warning',
        title: 'Error al generar PDF',
        text: 'PDFMonkey no pudo generar el documento en este momento. Intenta nuevamente en unos segundos.',
        time: 6000
      })
      return true
    }
  }
}
